import React, { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useApolloClient } from '@apollo/client';
import useStore from '@/stores/useStore';
import NotificationList from '@/components/notifications/NotificationList';
import useUnreadNotifications from '@/shared/hooks/useUnreadNotifications';
import { GET_NOTIFICATIONS } from '@/shared/queries';

const Notifications = () => {
  const setSnackbarState = useStore((state) => state.setSnackbarState);
  const { refetch: refetchUnreadCount } = useUnreadNotifications();
  const apolloClient = useApolloClient();

  // Handle notification errors
  const handleNotificationError = useCallback(() => {
    setSnackbarState({
      open: true,
      message: 'Failed to load notifications. Please try again.',
      severity: 'error',
    });
  }, [setSnackbarState]);

  useFocusEffect(
    useCallback(() => {
      // Refetch notifications when screen comes into focus
      apolloClient.refetchQueries({
        include: [GET_NOTIFICATIONS],
      });

      return () => {
        // Refresh bell icon when user navigates away
        refetchUnreadCount();
      };
    }, [apolloClient, refetchUnreadCount]),
  );

  return <NotificationList onError={handleNotificationError} />;
};

export default Notifications;
